import React from 'react';
import { DeleteModal } from '../delete-modal';
import { useForsideDeleteKvittering } from '../../features/kvitteringer';
import { IKvitteringData } from '../../ducks/kvittering/types';
interface IProps {
  kvittering: IKvitteringData;
  isOpen: boolean;
  onCancel: () => void;
}
export const ForsideDeleteModal = ({
  kvittering,
  isOpen,
  onCancel
}: IProps) => {
  const {
    mutate: onDeleteKvittering
  } = useForsideDeleteKvittering(kvittering);
  return <DeleteModal isOpen={isOpen} onCancel={onCancel} onDelete={() => {
    onDeleteKvittering();
    onCancel();
  }} title="Er du sikker på at du vil slette tilsynet?" confirmText="Ja, jeg vil slette tilsynet" cancelText="Avbryt" data-sentry-element="DeleteModal" data-sentry-component="ForsideDeleteModal" data-sentry-source-file="index.tsx" />;
};